import $ from 'jquery';

/** @type {JQueryValidation.ValidationOptions} */
const validationOptions = {
	rules: {
		from: {
			required: true,
			// Ensure date validation (including min/max validation) is applied
			date: true,
			dateISO: true,
		},
		to: {
			// Ensure date validation (including min/max validation) is applied
			date: true,
			dateISO: true,
		},
		'custom-fee': {
			required: {
				depends() {
					return $('#fee').val() === 'custom';
				},
			},
		},
	},
	messages: {
		'given-name': 'Bitte geben Sie Ihren Vornamen an.',
		name: 'Bitte geben Sie Ihren Nachnamen an.',
		'street-address': 'Bitte geben Sie Ihre Adresse an.',
		city: 'Bitte geben Sie Ihren Wohnort an.',
		phone: 'Bitte geben Sie Ihre Telefonnummer an.',
		statute: 'Sie müssen unserer Satzung zustimmen.',
		terms: 'Sie müssen den Mietbedingungen zustimmen.',
		email: {
			required: 'Bitte geben Sie Ihre E-Mail-Adresse an.',
			email: 'Ihre E-Mail-Adresse muss das Format mail@example.com haben.',
		},
		event: 'Bitte nennen Sie uns den Namen der Veranstaltung.',
		iban: 'Bitte nennen Sie uns Ihre IBAN.',
		bic: 'Bitte nennen Sie die BIC Ihrer Bank.',
		from: {
			required: 'Bitte nennen Sie uns das Veranstaltungsdatum.',
			min: 'Bitte überprüfen Sie das Veranstaltungsdatum.',
			date: 'Bitte nennen Sie uns ein gültiges Veranstaltungsdatum.',
			dateISO: 'Bitte nennen Sie uns ein gültiges Veranstaltungsdatum.',
		},
		to: {
			min: 'Bitte überprüfen Sie das Veranstaltungsdatum.',
			date: 'Bitte nennen Sie uns ein gültiges Veranstaltungsdatum.',
			dateISO: 'Bitte nennen Sie uns ein gültiges Veranstaltungsdatum.',
		},
		'custom-fee': {
			required: 'Bitte geben Sie einen Betrag an.',
			min: 'Bitte geben Sie einen Betrag ab 10 € p.a. an.',
		},
	},
	errorPlacement(error, elm) {
		const name = $(elm).attr('name');
		if (name === 'from' || name === 'to') {
			error.appendTo(elm.parent().parent().parent());
		} else if (name === 'custom-fee') {
			error.appendTo(elm.parent().parent());
		} else {
			error.appendTo(elm.parent());
		}
	},
	highlight(elm, errorClass, validClass) {
		$(elm)
			.addClass(errorClass)
			.removeClass(validClass)
			.attr('aria-invalid', 'true')
			.attr('aria-errormessage', $(elm).attr('name') + '-error');
	},
	unhighlight(elm, errorClass, validClass) {
		$(elm)
			.removeClass(errorClass)
			.addClass(validClass)
			.attr('aria-invalid', 'false')
			.removeAttr('aria-errormessage');
	},
};

export default validationOptions;
